// extracted by mini-css-extract-plugin
module.exports = {"cardBody":"upcoming_cardBody__2VS_1","top":"upcoming_top__2pLu8","date":"upcoming_date__rqeqh","number":"upcoming_number__3NVgb","info":"upcoming_info__1Pb0d"};